export default __webpack_public_path__ + "static/media/allery-5.99413b3c.svg";